import { v4 } from "uuid";
import { ExcelRenderer } from "react-excel-renderer";
import { useSelector } from "react-redux";

const rowTemplate = [
  "group",
  "category",
  "subCategory",
  "productBrand",
  "productName",
  "productMrp",
  "productPrice",
  "lowStockAlert",
  "measurement Value",
  "measurement Unit",
  "inventoryQty",
  "productEANCode",
  "purchasePrice",
  "productCode",
  "productTax",
  "taxIncExc",
  "productHsnCode",
  "productImageArray",
];

const VendorExcelUpload = ({ onChange = () => {} }) => {
  const shopDetails = useSelector((state) => state.shopDetails);
  const taxList = useSelector((state) => state.taxList.taxList);
  const errorPopUp = () => {
    alert(
      "Invalid Excel Sheet, Please Download the Excel Template given in this page add your products and upload again."
    );
    onChange([]);
    //setDataArray([]);
    //ref.current.value = "";
  };
  const handleFileUpload = (e) => {
    let fileObj = e.target.files[0];
    let dataError = false;
    ExcelRenderer(fileObj, (err, data) => {
      console.error("Excel upload failed", data);
      if (err) {
        console.error("Excel upload failed", err);
      } else {
        if (rowTemplate.length !== data.rows[0].length) {
          errorPopUp();
          return;
        }
        for (var i = 0; i < data.rows[0].length; i++) {
          if (data.rows[0].includes(rowTemplate[i])) {
            continue;
          }

          errorPopUp();
          return;
        }
        let arr = [];
        for (let i = 1; i < data.rows.length; i++) {
          let rowArr = data.rows[i];
          let headingArr = data.rows[0];
          let count = 0;
          let mValue = "";
          let mUnit = "";
          if (rowArr.length <= 0) continue;
          let obj = {
            productId: v4(),
            addedDate: new Date().toISOString().substr(0, 10),
            shopId: shopDetails.shopId,
            status: "live",
            group: "",
            category: "",
            subCategory: "",
            productBrand: "",
            productName: "",
            productMrp: "",
            productPrice: "TBD",
            unitOfMeasurment: "Others",
            productEANCode: "TBD",
            purchasePrice: "",
            inventoryQty: 0,
            productCode: "",
            versionId: "1",
            latest: "true",
            lowStockAlert: 5,
            productImageArray: [],
            productType: "product",
            productTax: "",
            productTaxType: "",
            productHsnCode: "",
            taxIncExc: "",
            taxId: "",
            ...(["Outlet", "Employee"].includes(shopDetails.userType) && {
              shopId: shopDetails.shopId,
              parentShopId: shopDetails.ownerShopId,
            }),
          };
          console.log("rowArr", rowArr, headingArr);
          rowArr.forEach((data, index) => {
            if (count !== index) {
              for (let i = count; i < index; i++) {
                if (headingArr[i] === "category") {
                  obj = {
                    ...obj,
                    category: "Others",
                  };
                }
                if (headingArr[i] === "group") {
                  obj = {
                    ...obj,
                    group: "Others",
                  };
                }
                if (headingArr[i] === "productPrice") {
                  obj = {
                    ...obj,
                    productPrice: "TBD",
                  };
                }
                if (headingArr[i] === "lowStockAlert") {
                  obj = {
                    ...obj,
                    lowStockAlert: "5",
                  };
                }
                if (headingArr[i] === "productImageArray") {
                  obj = {
                    ...obj,
                    productImageArray: [],
                  };
                }
                if (headingArr[i] === "inventoryQty") {
                  obj = {
                    ...obj,
                    inventoryQty: parseFloat(data || 0),
                    count: parseFloat(data || 0),
                  };
                }
                if (
                  headingArr[i] === "measurement Value" ||
                  headingArr[i] === "measurement Unit"
                ) {
                  obj = {
                    ...obj,
                    unitOfMeasurment: "Others",
                  };
                }

                if (headingArr[i] === "subCategory") {
                  obj = {
                    ...obj,
                    subCategory: "Others",
                  };
                }
                if (headingArr[i] === "productEANCode") {
                  obj = {
                    ...obj,
                    productEANCode: "TBD",
                  };
                }
              }
              count = index;
            }
            if (count === index) {
              if (headingArr[count] === "measurement Value") {
                mValue = data.toString();
                count++;
                return;
              } else if (headingArr[count] === "measurement Unit") {
                mUnit = data;
                count++;
                return;
              } else if (headingArr[count] === "productImageArray") {
                var arr = data.split(",");
                obj = {
                  ...obj,
                  [headingArr[count]]: arr,
                };
              } else if (headingArr[count] === "productTax") {
                obj = {
                  ...obj,
                  [headingArr[count]]: data,
                };
              } else if (headingArr[count] === "taxIncExc") {
                obj = {
                  ...obj,
                  [headingArr[count]]: data,
                };
              } else if (headingArr[count] === "inventoryQty") {
                obj = {
                  ...obj,
                  inventoryQty: parseFloat(data || 0),
                  count: parseFloat(data || 0),
                };
              } else {
                obj = {
                  ...obj,
                  [headingArr[count]]: data.toString(),
                };
              }

              if (count === rowArr.length - 1) {
                if (mValue !== "" && mUnit !== "") {
                  obj = {
                    ...obj,
                    unitOfMeasurment: mValue + " " + mUnit,
                  };
                }
              }
            }
            count++;
          });
          if (obj.productTax && obj.taxIncExc === "Inclusive/Exclusive") {
            // setErrorInData(true);
            dataError = true;
          }
          arr.push(obj);
        }

        if (dataError) {
          onChange([]);
          //setDataArray([]);
          // setErrorInData(false);
          dataError = false;
          // e.target.value = ''
          return alert(
            `Tax inclusive/exclusive field cannot be empty if tax is selected, please choose any one tax type and upload again`
          );
        }
        if (arr.length > 0) {
          arr.forEach((data) => {
            taxList?.forEach((value) => {
              data.count = data.inventoryQty;
              data.isExist = false;
              data.status = "new";
              if (data.productTax === value.taxName) {
                data.taxId = value.taxId;
              }
            });
          });
        }
        onChange(arr);
      }
    });
  };
  return (
    <input
      type={"file"}
      onChange={handleFileUpload}
      id="excelInput"
      className="fileInput"
      style={{
        marginLeft: "20px",
        width: 200,
      }}
      accept="application/vnd.ms-excel,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      //onClick={() => (ref.current.value = "")}
    />
  );
};

export default VendorExcelUpload;
